
import React from 'react';
import NavBar from '@/components/layout/NavBar';
import Footer from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import FadeInSection from '@/components/ui/FadeInSection';
import { useLanguage } from '@/components/i18n/language-provider';

const ComingSoon = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow flex items-center">
        <div className="container mx-auto px-6 py-20">
          <FadeInSection>
            <div className="max-w-3xl mx-auto text-center">
              <span className="inline-block rounded-full px-3 py-1 text-sm bg-primary/10 text-primary font-medium mb-4">
                {t('comingSoon')}
              </span>
              <h1 className="text-4xl md:text-5xl font-bold mb-8">{t('comingSoon.title')}</h1>
              <p className="text-lg text-muted-foreground mb-10 mx-auto max-w-2xl">
                {t('comingSoon.description')}
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  size="lg" 
                  className="px-6 font-medium text-base bg-brand-pink hover:bg-brand-pink/90"
                  onClick={() => window.open("https://meetings-na2.hubspot.com/gilmar/demo-keystle-website", "_blank")}
                >
                  {t('nav.scheduleDemo')}
                  <Calendar className="ml-2 h-4 w-4" />
                </Button>
                <Button 
                  variant="outline" 
                  size="lg"
                  className="px-6 font-medium text-base"
                  onClick={() => navigate('/')}
                >
                  {t('error.returnHome')}
                </Button>
              </div>
            </div>
          </FadeInSection>
          
          {/* Abstract shapes */}
          <div className="absolute -bottom-10 -left-10 h-64 w-64 rounded-full bg-brand-pink/10 filter blur-3xl opacity-70 -z-10"></div>
          <div className="absolute -top-10 -right-10 h-64 w-64 rounded-full bg-brand-purple/10 filter blur-3xl opacity-70 -z-10"></div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ComingSoon;
